function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Mobile Menu
 *    Scripts for the mobile menu
 *
 *  Version:
 *    1.0.0 - 2020/03/02
 */

import * as ResponsiveSizes from './../../settings/Responsive';
import { HEADER_INNER, CLASS_DOWN } from './../../sections/header/Header';
export var MOBILE_MENU_SELECTOR = '[data-mobile-menu]';
export var MOBILE_MENU_TOGGLE = '[data-mobile-menu-toggle]';
export var MOBILE_MENU_MENU_SELECTOR = '[data-mobile-menu-menu]';
export var MOBILE_SUBMENU_CONTAINER = '[data-mobile-submenu]';
export var MOBILE_SUBMENU_TOGGLE = '[data-mobile-submenu-toggle]';
export var MOBILE_MENU_SUBMENU_BACK = '[data-mobile-submenu-back]';
export var MOBILE_MENU_SUBMENU_HANDLE = 'data-mobile-submenu-handle';
export var CLASS_MENU_OPEN = 'is-menu-open';
export var CLASS_ACTIVE = 'is-active';
export var MobileMenu = /*#__PURE__*/function () {
  function MobileMenu(template, container) {
    var _this = this;
    _classCallCheck(this, MobileMenu);
    this.container = container;
    this.headerInner = template.find(HEADER_INNER);
    this.menuTargets = [container, $('body'), this.headerInner];
    this.submenuToggle = container.find(MOBILE_SUBMENU_TOGGLE);
    this.menu = container.find(MOBILE_MENU_MENU_SELECTOR);
    this.body = $('body');
    this.submenu = container.find(MOBILE_SUBMENU_CONTAINER);
    // this.subsubmenu = container.find(MOBILE_MENU_SUBSUBMENU);

    template.on('click touch', MOBILE_MENU_TOGGLE, function (e) {
      return _this.onMenuToggle(e);
    });
    $(window).on('resize orientationchange', function () {
      return _this.onResize();
    });
    container.on('click touch', MOBILE_SUBMENU_TOGGLE, function (e) {
      return _this.onSubmenuToggle(e);
    });
    container.on('click touch', MOBILE_MENU_SUBMENU_BACK, function (e) {
      return _this.onSubmenuBack(e);
    });
  }
  _createClass(MobileMenu, [{
    key: "open",
    value: function open() {
      var _this2 = this;
      this.menuTargets.forEach(function (e) {
        return e.addClass(CLASS_MENU_OPEN);
      });
      //Show the logo after a tiny delay to await for RAF to finish.
      this.headerInner.removeClass(CLASS_DOWN);
      setTimeout(function () {
        return _this2.checkHeader();
      }, 50);

      //Set the height of the screen to prevent background scrolling
      var vpH = $(window).innerHeight();
      setTimeout(function () {
        _this2.body.css('height', "".concat(vpH.toString(), "px"));
      }, 500);
    }
  }, {
    key: "checkHeader",
    value: function checkHeader() {
      var _this3 = this;
      if (!this.headerInner.hasClass(CLASS_DOWN)) {
        clearInterval(this.headerInt);
        return;
      }
      this.headerInner.removeClass(CLASS_DOWN);
      setTimeout(function () {
        return _this3.checkHeader();
      }, 100);
    }
  }, {
    key: "close",
    value: function close() {
      this.menuTargets.forEach(function (e) {
        return e.removeClass(CLASS_MENU_OPEN);
      });
      this.body.css('height', '');
      this.submenu.removeClass(CLASS_ACTIVE);
      this.menu.addClass(CLASS_ACTIVE);
    }
  }, {
    key: "toggleOpen",
    value: function toggleOpen() {
      if (this.container.hasClass(CLASS_MENU_OPEN)) return this.close();
      this.open();
    }
  }, {
    key: "onMenuToggle",
    value: function onMenuToggle(e) {
      this.cancelEvents(e) && this.toggleOpen();
    }
  }, {
    key: "onResize",
    value: function onResize() {
      if ($(window).width() < ResponsiveSizes.medium) return;
      this.menuTargets.forEach(function (e) {
        return e.removeClass(CLASS_MENU_OPEN);
      });
      this.body.css('height', '');
    }
  }, {
    key: "onSubmenuToggle",
    value: function onSubmenuToggle(e) {
      this.cancelEvents(e);
      var subToggle = $(e.currentTarget);
      var handle = subToggle.attr(MOBILE_MENU_SUBMENU_HANDLE);
      var submenu = this.container.find("[".concat(MOBILE_MENU_SUBMENU_HANDLE, "=\"").concat(handle, "\"]"));
      if (!submenu.length) return;
      this.menu.removeClass(CLASS_ACTIVE);
      submenu.addClass(CLASS_ACTIVE);
    }
  }, {
    key: "onSubmenuBack",
    value: function onSubmenuBack(e) {
      this.cancelEvents(e);
      this.submenu.removeClass(CLASS_ACTIVE);
      this.menu.addClass(CLASS_ACTIVE);
    }
  }, {
    key: "cancelEvents",
    value: function cancelEvents(e) {
      e.preventDefault(), e.stopPropagation();
      return true;
    }
  }]);
  return MobileMenu;
}();